import p1 from "@/assets/product-1.jpg";
import p2 from "@/assets/product-2.jpg";
import p3 from "@/assets/product-3.jpg";
import p4 from "@/assets/product-4.jpg";
import p5 from "@/assets/product-5.jpg";
import p6 from "@/assets/product-6.jpg";

const map: Record<string, string> = {
  "linen-shirt": p1,
  "wool-trouser": p2,
  "wool-coat": p3,
  "cable-knit": p4,
  "denim-jean": p5,
  "slip-dress": p6,
};

export function transformImage(url: string, width = 600, quality = 70) {
  if (!url) return url;
  try {
    if (url.includes("/storage/v1/object/public/")) {
      const u = new URL(url.replace("/storage/v1/object/public/", "/storage/v1/render/image/public/"));
      u.searchParams.set("width", String(width));
      u.searchParams.set("quality", String(quality));
      u.searchParams.set("resize", "contain");
      return u.toString();
    }
  } catch {}
  return url;
}

export function resolveImage(slug: string, fallback?: string, width = 600) {
  if (map[slug]) return map[slug];
  if (fallback && !fallback.startsWith("/src-assets/")) return transformImage(fallback, width);
  return p1;
}

